import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionContractByInstitutionId: IInstitutionContractLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_LOAD_BY_INSTITUTION_ID,
            institutionId
        }
    },
    LoadInstitutionContractById: IInstitutionContractLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IInstitutionContractLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionContractLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionContract: IInstitutionContractSaveActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_SAVE,
            formData
        }
    },
    SaveSuccess: IInstitutionContractSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionContractSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionContract: IInstitutionContractValidateActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IInstitutionContractValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionContractValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionContract: IInstitutionContractCreateActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONCONTRACT_CREATE,
            institutionId
        }
    },
    CreateSuccess: IInstitutionContractCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionContractCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncInstitutionContract: IInstitutionContractSyncActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONCONTRACT_SYNC,
            institutionId
        }
    },
    SyncSuccess: IInstitutionContractSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: IInstitutionContractSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionContractClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_CLEAR,
            propertiesToClear
        }
    },

    Filter: IInstitutionContractFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONCONTRACT_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTIONCONTRACT_LOAD_BY_INSTITUTION_ID = "ACTION_INSTITUTIONCONTRACT_LOAD_BY_INSTITUTION_ID",
    ACTION_INSTITUTIONCONTRACT_LOAD_BY_ID = "ACTION_INSTITUTIONCONTRACT_LOAD_BY_ID",
    ACTION_INSTITUTIONCONTRACT_LOAD_SUCCESS = "ACTION_INSTITUTIONCONTRACT_LOAD_SUCCESS",
    ACTION_INSTITUTIONCONTRACT_LOAD_FAILURE = "ACTION_INSTITUTIONCONTRACT_LOAD_FAILURE",

    ACTION_INSTITUTIONCONTRACT_SAVE = "ACTION_INSTITUTIONCONTRACT_SAVE",
    ACTION_INSTITUTIONCONTRACT_SAVE_SUCCESS = "ACTION_INSTITUTIONCONTRACT_SAVE_SUCCESS",
    ACTION_INSTITUTIONCONTRACT_SAVE_FAILURE = "ACTION_INSTITUTIONCONTRACT_SAVE_FAILURE",

    ACTION_INSTITUTIONCONTRACT_VALIDATE = "ACTION_INSTITUTIONCONTRACT_VALIDATE",
    ACTION_INSTITUTIONCONTRACT_VALIDATE_SUCCESS = "ACTION_INSTITUTIONCONTRACT_VALIDATE_SUCCESS",
    ACTION_INSTITUTIONCONTRACT_VALIDATE_FAILURE = "ACTION_INSTITUTIONCONTRACT_VALIDATE_FAILURE",

    ACTION_INSTITUTIONCONTRACT_CREATE = "ACTION_INSTITUTIONCONTRACT_CREATE",
    ACTION_INSTITUTIONCONTRACT_CREATE_SUCCESS = "ACTION_INSTITUTIONCONTRACT_CREATE_SUCCESS",
    ACTION_INSTITUTIONCONTRACT_CREATE_FAILURE = "ACTION_INSTITUTIONCONTRACT_CREATE_FAILURE",

    ACTION_INSTITUTIONCONTRACT_SYNC = "ACTION_INSTITUTIONCONTRACT_SYNC",
    ACTION_INSTITUTIONCONTRACT_SYNC_SUCCESS = "ACTION_INSTITUTIONCONTRACT_SYNC_SUCCESS",
    ACTION_INSTITUTIONCONTRACT_SYNC_FAILURE = "ACTION_INSTITUTIONCONTRACT_SYNC_FAILURE",

    ACTION_INSTITUTIONCONTRACT_CLEAR = "ACTION_INSTITUTIONCONTRACT_CLEAR",

    ACTION_INSTITUTIONCONTRACT_FILTER = "ACTION_INSTITUTIONCONTRACT_FILTER";

export interface IInstitutionContractLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONCONTRACT_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
}

export interface IInstitutionContractLoadByInstitutionIdActionCreator {
    (institutionId: number): IInstitutionContractLoadByInstitutionIdAction;
}

export interface IInstitutionContractLoadSuccessAction {
    type: "ACTION_INSTITUTIONCONTRACT_LOAD_SUCCESS";
    formData: Dtos.InstitutionContract | Dtos.InstitutionContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionContractLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionContract | Dtos.InstitutionContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionContractLoadSuccessAction;
}

export interface IInstitutionContractLoadFailureAction {
    type: "ACTION_INSTITUTIONCONTRACT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionContractLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionContractLoadFailureAction;
}

export interface IInstitutionContractLoadByIdAction {
    type: "ACTION_INSTITUTIONCONTRACT_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionContractLoadByIdActionCreator {
    (id: number): IInstitutionContractLoadByIdAction;
}

export interface IInstitutionContractSaveAction {
    type: "ACTION_INSTITUTIONCONTRACT_SAVE";
    formData: Dtos.InstitutionContract;

}

export interface IInstitutionContractSaveActionCreator {
    (
        formData: Dtos.InstitutionContract
    ): IInstitutionContractSaveAction;
}

export interface IInstitutionContractSaveSuccessAction {
    type: "ACTION_INSTITUTIONCONTRACT_SAVE_SUCCESS";
    formData: Dtos.InstitutionContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionContractSaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionContractSaveSuccessAction;
}

export interface IInstitutionContractSaveFailureAction {
    type: "ACTION_INSTITUTIONCONTRACT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionContractSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionContractSaveFailureAction;
}

export interface IInstitutionContractValidateAction {
    type: "ACTION_INSTITUTIONCONTRACT_VALIDATE";
    formData: Dtos.InstitutionContract;

}

export interface IInstitutionContractValidateActionCreator {
    (
        formData: Dtos.InstitutionContract
    ): IInstitutionContractValidateAction;
}

export interface IInstitutionContractValidateSuccessAction {
    type: "ACTION_INSTITUTIONCONTRACT_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionContractValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionContractValidateSuccessAction;
}

export interface IInstitutionContractValidateFailureAction {
    type: "ACTION_INSTITUTIONCONTRACT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionContractValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionContractValidateFailureAction;
}

export interface IInstitutionContractCreateAction {
    type: "ACTION_INSTITUTIONCONTRACT_CREATE",
    institutionId: number
}

export interface IInstitutionContractCreateActionCreator {
    (institutionId: number): IInstitutionContractCreateAction
}

export interface IInstitutionContractCreateSuccessAction {
    type: "ACTION_INSTITUTIONCONTRACT_CREATE_SUCCESS";
    formData: Dtos.InstitutionContract;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IInstitutionContractCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionContract,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionContractCreateSuccessAction;
}

export interface IInstitutionContractCreateFailureAction {
    type: "ACTION_INSTITUTIONCONTRACT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionContractCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionContractCreateFailureAction;
}

export interface IInstitutionContractClearAction {
    type: "ACTION_INSTITUTIONCONTRACT_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionContractClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionContractClearAction;
}

export interface IInstitutionContractFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionContractFilterAction;
}

export interface IInstitutionContractFilterAction {
    type: "ACTION_INSTITUTIONCONTRACT_FILTER";
    formFilter: IFormFilter;
}

export interface IInstitutionContractSyncAction {
    type: "ACTION_INSTITUTIONCONTRACT_SYNC",
    institutionId: number
}

export interface IInstitutionContractSyncActionCreator {
    (institutionId: number): IInstitutionContractSyncAction
}

export interface IInstitutionContractSyncSuccessAction {
    type: "ACTION_INSTITUTIONCONTRACT_SYNC_SUCCESS";
    formData: Dtos.InstitutionContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionContractSyncSuccessActionCreator {
    (
        formData: Dtos.InstitutionContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionContractSyncSuccessAction;
}

export interface IInstitutionContractSyncFailureAction {
    type: "ACTION_INSTITUTIONCONTRACT_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionContractSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionContractSyncFailureAction;
}

export type InstitutionContractAction =
    IInstitutionContractLoadByInstitutionIdAction |
    IInstitutionContractLoadByIdAction |
    IInstitutionContractLoadFailureAction |
    IInstitutionContractLoadSuccessAction |
    IInstitutionContractSaveAction |
    IInstitutionContractSaveSuccessAction |
    IInstitutionContractSaveFailureAction |
    IInstitutionContractValidateAction |
    IInstitutionContractValidateSuccessAction |
    IInstitutionContractValidateFailureAction |
    IInstitutionContractCreateAction |
    IInstitutionContractCreateSuccessAction |
    IInstitutionContractCreateFailureAction |
    IInstitutionContractSyncAction |
    IInstitutionContractSyncSuccessAction |
    IInstitutionContractSyncFailureAction |
    IInstitutionContractClearAction | 
    IInstitutionContractFilterAction;
